<template>
    <el-dialog v-model="dialogShow" title="升级会员" width="600px" align-center :before-close="handleClose"
        destroy-on-close>
        <div class="inrect">
            <div class="rectbox">
                <img v-if="payCodeUrl!=''" :src="payCodeUrl" alt="" style="max-width: 100%;"/>
                <svg-icon v-else svgname="ic_qrcode" :size="50" fill="var(--ek-text-color3)" />
            </div>
            <div class="dvprice" v-if="saleItem!=null">
                <span>{{saleItem.price}}</span>
                <span>元</span>
            </div>
            <div v-if="orderId==''" class="vc-flex dvpays">
                <div @click="createOrder" class="bnt-create focus-s">微信支付</div>
            </div>
            <div v-else class="vc-flex dvpays">
                <div @click="queryOrder" class="bnt-create focus-s">支付完成</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import httpClient from '@/commom/http/httpClient';
import SvgIcon from '@/components/SvgIcon.vue';

export default {
    name: 'MemberPaymentDialog',
    components: {
        SvgIcon
    },
    props: {
        showDialog: Boolean,
        saleItem:Object
    },
    watch: {
        showDialog: function (nval, old) {
            this.dialogShow = nval
        }
    },
    data() {
        return {
            dialogShow: this.showDialog,
            orderId:"",
            payCodeUrl:""

        }
    },
    mounted: function () {

    },
    methods: {
        ///关闭窗口
        handleClose: function (done) {
            this.$emit('closeDialog', done)
        },
        ///创建订单
        createOrder:function(){
            if(this.saleItem==null){
                this.$message.error("参数错误")
                return
            }
            var that = this
            var req = {
                itemKey:this.saleItem.key
            }
            httpClient.invoke("SaleAPI.CreateVIPOrder",req,function(res){
                if(res.error){
                    that.$message.error(res.error)
                    return
                }
                if(!res.success){
                    that.$message.error("创建订单失败")
                    return
                }
                that.orderId = res.data.orderId
                that.payCodeUrl = res.data.qrcode
                setTimeout(()=>{
                    that.queryOrder()
                },3000)
            })

        },
        ///重复查询
        replaceQuery:function(){
            if(!this.dialogShow){
                ///对话框已经关闭，停止查询
                return
            }
            setTimeout(()=>{
                this.queryOrder()
            },2000)
        },
        ///查询订单状态
        queryOrder:function(){
            var req = {
                orderId:this.orderId
            }
            var that = this
            httpClient.invoke("SaleAPI.QueryOrderPayment",req,function(res){
                if(res.error){
                    that.replaceQuery()
                    return
                }
                if(!res.success){
                    that.replaceQuery()
                    return
                }
            
                that.handleClose(true)
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bnt-create {
    background: var(--ek-color-primary);
    color: white;
    line-height: 35px;
    width: 150px;
    display: flex;
    justify-content: center;
    border-radius: 10px;
}

.dvpays {
    margin-top: 50px;
}

.dvprice {
    margin-top: 20px;
}

.inrect {
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sitem {
    margin-top: 15px;
}

.rectbox {
    width: 220px;
    height: 220px;
    background: var(--ek-card-color1);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--ek-split-lineColor);
}
</style>